import { message } from 'antd';
import { CLONE_BUS_AS_TEMPLATE_URL } from './../../../utils/api-url';
import { postCall } from "./../../../utils/network.util";

export const handleCloneBusAsTemplate=(busId,identifier,onSuccess=()=>{},onFailure=()=>{})=>{
      var cloneBus = postCall(CLONE_BUS_AS_TEMPLATE_URL, {
        busId : busId,
        templateName:identifier
      });
      cloneBus.then((data) => {
        if(data.status === "SUCCESS"&&data.payload.Status === "SUCCESS"){
          message.success(data.payload.Message);
          onSuccess();
        }else{
          onFailure();
        }
      })
      .catch((reason)=> {
        onFailure();
      })
  }